import { SS } from '../engine/gpu-flags.js';
import { REVERSE_DEPTH_COMPARE } from '../engine/render-target.js';

let _cachedSceneBGL = null;
let _cachedDevice = null;
function getSceneBindGroupLayout(engine) {
  const device = engine._device;
  if (_cachedSceneBGL && _cachedDevice === device) {
    return _cachedSceneBGL;
  }
  _cachedDevice = device;
  _cachedSceneBGL = device.createBindGroupLayout({
    label: "scene",
    entries: [
      { binding: 0, visibility: SS.VERTEX | SS.FRAGMENT, buffer: { type: "uniform" } },
      { binding: 1, visibility: SS.FRAGMENT, buffer: { type: "uniform" } }
    ]
  });
  return _cachedSceneBGL;
}
function clearSceneBGLCache() {
  _cachedSceneBGL = null;
  _cachedDevice = null;
}
function updateWorldMatrixUBOs(engine, packets) {
  const device = engine._device;
  for (const p of packets) {
    const wm = p.mesh.worldMatrix;
    if (p.mesh.worldMatrixVersion !== p._lastWorldVersion) {
      device.queue.writeBuffer(p.meshUBO, 0, wm);
      p._lastWorldVersion = p.mesh.worldMatrixVersion;
    }
  }
}
function createDefaultPipelineDescriptor(opts) {
  const target = opts._blend ? { format: opts._format, blend: opts._blend } : { format: opts._format };
  return {
    label: opts._label,
    layout: opts._engine._device.createPipelineLayout({ bindGroupLayouts: opts._bgls }),
    vertex: { module: opts._vertModule, entryPoint: "main", buffers: opts._vertexBuffers },
    fragment: { module: opts._fragModule, entryPoint: "main", targets: [target] },
    depthStencil: {
      format: opts._depthStencilFormat ?? "depth24plus-stencil8",
      depthCompare: opts._depthCompare ?? REVERSE_DEPTH_COMPARE,
      depthWriteEnabled: opts._depthWriteEnabled ?? true
    },
    multisample: { count: opts._msaaSamples },
    primitive: { topology: "triangle-list", cullMode: opts._cullMode ?? "back", frontFace: "ccw" }
  };
}

export { clearSceneBGLCache, createDefaultPipelineDescriptor, getSceneBindGroupLayout, updateWorldMatrixUBOs };
//# sourceMappingURL=scene-helpers.js.map
